<script setup lang="ts">
import { useAddressSystemStore } from '@/store/addressSystem'
import { useDialogsStore } from '@/store/dialogs/dialogs'
import { DIALOGS } from '@/store/dialogs/dialogs.constants'

const ANIMATION_TIMEOUT = 100

const { isMobile } = useResponsive()

const { showDialog, closeDialog } = useDialogsStore()
const { dialogs } = storeToRefs(useDialogsStore())
const { setVisibleAddressSystemDialog } = useAddressSystemStore()

const component = computed(() => {
  return isMobile.value
    ? resolveComponent('TheBottomSheet')
    : resolveComponent('TheDialog')
})

const onClickAuth = () => {
  closeDialog(DIALOGS.CHECK_ADDRESS)
  closeDialog(DIALOGS.PRODUCT)

  setTimeout(() => showDialog(DIALOGS.LOGIN), ANIMATION_TIMEOUT)
}

const onClickAddress = () => {
  closeDialog(DIALOGS.CHECK_ADDRESS)
  closeDialog(DIALOGS.PRODUCT)

  setTimeout(() => setVisibleAddressSystemDialog(true), ANIMATION_TIMEOUT)
}
</script>

<template>
  <component
    :is="component"
    class="dialog-check-address"
    :model-value="dialogs.checkAddress.visible"
    v-bind="dialogs.checkAddress.props"
    @update:model-value="closeDialog(DIALOGS.CHECK_ADDRESS)"
  >
    <div class="dialog-check-address__title">Какой у вас адрес?</div>

    <div class="dialog-check-address__text">
      Хотим убедиться, что вы&nbsp;в&nbsp;зоне доставки. Адрес сохраним для
      будущих заказов
    </div>

    <div class="dialog-check-address__actions">
      <the-button variant="tertiary" block @click="onClickAuth">
        Войти по номеру телефона
      </the-button>

      <the-button variant="secondary" block @click="onClickAddress">
        Указать адрес
      </the-button>
    </div>
  </component>
</template>

<style scoped lang="scss">
.dialog-check-address {
  &__title {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 800;
    line-height: 23px;
    color: var(--ui-text-primary);
    letter-spacing: -0.02em;

    @include media('>=desktop-mini') {
      margin-bottom: 16px;
      text-align: center;
    }
  }

  &__text {
    max-width: 260px;
    margin-bottom: 24px;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: var(--ui-text-secondary);
    letter-spacing: -0.02em;

    @include media('>=desktop-mini') {
      max-width: 370px;
      margin: 0 auto 32px;
      font-size: 16px;
      line-height: 21px;
      text-align: center;
    }
  }

  &__actions {
    display: grid;
    gap: 16px;

    @include media('>=desktop-mini') {
      max-width: 260px;
      padding-bottom: 8px;
      margin: 0 auto;
    }
  }
}
</style>
